import { type ReactNode, createContext, useContext } from 'react';

export interface Session<T = {}> {
  isAuthenticated: boolean;
  authenticate: (authenticator: string, credentials: Record<string, unknown>) => Promise<void>;
  invalidate: () => Promise<void>;
  data: T;
}

export const SessionContext = createContext<Session | null>(null);

export function SessionProvider({
  session,
  children,
}: {
  session: Session;
  children: ReactNode;
}): JSX.Element {
  return <SessionContext.Provider value={session}>{children}</SessionContext.Provider>;
}

export function useSession<T = {}>(): Session<T> {
  const context = useContext(SessionContext);
  if (context === null) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return context as Session<T>;
}
